<div class="container mt-4">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Cargos</li>
    </ol>
  </nav>

  <div class="list-header">
    <div class="list-header__title">
      <h1 class="mb-0">Lista de Cargos</h1>
      <span class="result-badge" *ngIf="totalElements > 0">{{ totalElements }} registros</span>
    </div>
    <button mat-raised-button color="primary" (click)="router.navigate(['/responsibilities/create'])">
      <mat-icon>add</mat-icon>
      Novo Cargo
    </button>
  </div>

  <!-- Filtro -->
  <mat-form-field appearance="outline" class="filter-field">
    <mat-label>Buscar cargo</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Digite para filtrar..." />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <!-- Tabela -->
  <div class="table-container mat-elevation-z2">
    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="loading">
      <mat-spinner diameter="48"></mat-spinner>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort class="w-100">
        <!-- Nome -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome do Cargo</th>
          <td mat-cell *matCellDef="let responsibility">
            <span class="cell-text" [matTooltip]="responsibility.name">{{ responsibility.name }}</span>
          </td>
        </ng-container>

        <!-- Empresa -->
        <ng-container matColumnDef="officeFantasyName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Empresa</th>
          <td mat-cell *matCellDef="let responsibility">{{ responsibility.officeFantasyName }}</td>
        </ng-container>

        <!-- Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-header">Ações</th>
          <td mat-cell *matCellDef="let responsibility" class="actions-cell">
            <button mat-icon-button color="primary" (click)="onEdit(responsibility)" matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="onDelete(responsibility)" matTooltip="Desativar">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-row"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell empty-state" [attr.colspan]="displayedColumns.length">
            <img src="../../../../../assets/img/folder.png" alt="Nenhum resultado" width="80" />
            <p class="empty-state__text">Nenhum cargo encontrado.</p>
            <button mat-stroked-button color="primary" (click)="router.navigate(['/responsibilities/create'])">
              Criar primeiro cargo
            </button>
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="currentPage"
      [pageSizeOptions]="[10, 20, 50]"
      showFirstLastButtons
      aria-label="Selecionar página"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </div>
</div>
